import * as React from 'react';
import classnames from 'classnames';
import { Expander } from '@grandvisionhq/common';
import { pushImageGalleryOpenEvent } from '../Analytics/events/ImageGalleryEvents.js';
import { VtoBanner } from './components/VtoBanner/VtoBanner.js';
import { ProductImage } from './components/ProductImage/ProductImage.js';
import { ZoomModal } from './components/ZoomModal/ZoomModal.js';
import { DittoContainer } from '../VTO/Ditto/components/DittoContainer/DittoContainer.js';

const desktopImageSizes = {
    M: 768,
    L: 1024,
    XL: 1440,
    MAX: 1440
};
const ProductImageGallery = ({ initialImages , isVtoEnabled , expandableImages , showMoreLabel , showLessLabel , handleGalleryExpansion , handleImageInteraction , isImageVisible , setVtoActive , vtoActive , zoomModalOpenIndex , buttonClickedForZoomRef , vtoBanner , sku ,  })=>{
    if (!initialImages || initialImages.length === 0) {
        return null;
    }
    const handleImageClick = (index, altText)=>{
        handleImageInteraction(index);
        // push dataLayer event only for the first image
        if (sku && index === 0) {
            pushImageGalleryOpenEvent(altText, index, sku);
        }
    };
    return /*#__PURE__*/ React.createElement("section", {
        "data-t": "product-image-gallery",
        className: classnames('product-image-gallery', {
            'product-image-gallery--full-width': initialImages.length <= 2
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-image-gallery__images"
    }, initialImages.map((image, index)=>/*#__PURE__*/ React.createElement("div", {
            key: image.label,
            className: classnames('product-image-gallery__image', {
                'product-image-gallery__image--highlighted': image.highlighted
            })
        }, image.vto && isVtoEnabled && !vtoActive && vtoBanner && /*#__PURE__*/ React.createElement(VtoBanner, {
            vtoBanner: vtoBanner,
            altText: image.altText,
            imageUrl: image.url,
            onClick: ()=>setVtoActive(true)
        }), image.vto && vtoActive && isVtoEnabled && !!sku && /*#__PURE__*/ React.createElement("div", {
            className: "product-image-gallery__vto product-image"
        }, /*#__PURE__*/ React.createElement(DittoContainer, {
            sku: sku,
            onClose: ()=>setVtoActive(false)
            ,
            vtoBanner: vtoBanner
        })), !image.vto && /*#__PURE__*/ React.createElement(ProductImage, {
            ref: index === zoomModalOpenIndex ? buttonClickedForZoomRef : null,
            onClick: ()=>handleImageClick(index, image.altText)
            ,
            altText: image.altText,
            imageUrl: image.url,
            zoom: image.zoom,
            imageSizes: desktopImageSizes,
            sku: sku
        }))
    )), !!expandableImages.length && /*#__PURE__*/ React.createElement(Expander, {
        className: "product-image-gallery__expanded-images",
        showMoreLabel: showMoreLabel,
        showLessLabel: showLessLabel,
        id: "gallery-expander",
        onExpandCallback: handleGalleryExpansion
    }, expandableImages.map((image, index)=>/*#__PURE__*/ React.createElement("div", {
            key: image.label,
            className: classnames('product-image-gallery__expanded-image', {
                'product-image-gallery__image--highlighted': image.highlighted
            })
        }, !!image.vto && vtoBanner && /*#__PURE__*/ React.createElement(VtoBanner, {
            vtoBanner: vtoBanner,
            altText: image.altText,
            imageUrl: image.url,
            onClick: ()=>setVtoActive(true)
            ,
            showImage: isImageVisible
        }), !image.vto && /*#__PURE__*/ React.createElement(ProductImage, {
            ref: index + initialImages.length === zoomModalOpenIndex ? buttonClickedForZoomRef : null,
            onClick: ()=>handleImageClick(index + initialImages.length, image.altText)
            ,
            altText: image.altText,
            imageUrl: image.url,
            showImage: isImageVisible,
            imageSizes: desktopImageSizes,
            zoom: image.zoom,
            sku: sku
        }))
    )), /*#__PURE__*/ React.createElement(ZoomModal, {
        isOpen: zoomModalOpenIndex !== null,
        openingIndex: zoomModalOpenIndex,
        onClose: ()=>handleImageInteraction(null)
        ,
        images: [
            ...initialImages,
            ...expandableImages
        ]
    }));
};

export { ProductImageGallery };
//# sourceMappingURL=ProductImageGallery.js.map
